export const UNIT_LANGUAGES = ["en", "es", "ca"];
export const UNIT_LANGUAGE_LABELS = { en: "English", es: "Español", ca: "Català" };

const text = (value) => typeof value === "string" ? value.trim() : "";
export const unitLanguage = (languageId) => String(languageId || "en").toLowerCase().split(/[-_]/)[0];

export function getUnitTranslations(unit) {
  const source = unit?.name_translations ?? unit?.data?.name_translations;
  const names = Object.fromEntries(UNIT_LANGUAGES.map((language) => [language, text(source?.[language])]));
  // Legacy labels have not been translated. Do not copy them into missing languages.
  if (!Object.values(names).some(Boolean)) names.en = text(unit?.name);
  return names;
}

export function getOfficialUnitName(unit, languageId) {
  const names = getUnitTranslations(unit);
  return names[unitLanguage(languageId)] || UNIT_LANGUAGES.map((language) => names[language]).find(Boolean) || text(unit?.name) || text(unit?.code);
}

export function getUnitName(unit, languageId) {
  return text(unit?.display_name) || getOfficialUnitName(unit, languageId);
}

export function unitSearchText(unit) {
  return [unit?.display_name, unit?.code, unit?.name, ...Object.values(getUnitTranslations(unit))].filter(Boolean).join(" ");
}

// Resolve by ID, never by an English label (different units may share a name).
// Current catalogue labels take precedence over stale embedded document labels.
export function getDocumentUnitName(unit, unitId, units, languageId) {
  const id = unitId ?? unit?.id;
  const current = units instanceof Map ? units.get(String(id)) : units?.find((entry) => String(entry.id) === String(id));
  return getUnitName(current && typeof current === "object" ? current : unit, languageId) || (typeof current === "string" ? current : "");
}
